import create from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
export const useGlobalStore = create()(devtools(immer((set) => ({
    config: {},
    isInited: false,
    set: (config) => {
        set((state) => {
            state.config = config;
            state.isInited = true;
        });
    },
}))));
